import { render, staticRenderFns } from "./ModalOsAVencerArmazem.vue?vue&type=template&id=d9ee7106&scoped=true&"
import script from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencerArmazem.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencerArmazem.vue?vue&type=style&index=0&id=d9ee7106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ee7106",
  null
  
)

export default component.exports